import userStore from '@/store/modules/user.store'
import { HOME_ROUTE, routerState, extractExcludedPlatforms, extractAllowedPlatforms } from '../utils'

export default async (to, from, next) => {
  const excludedPlatforms = extractExcludedPlatforms(to)
  const allowedPlatforms = extractAllowedPlatforms(to)

  const signedInPlatform = userStore.state.signedInPlatform
  const isExcluded = excludedPlatforms.includes(signedInPlatform)
  const isAllowed = allowedPlatforms ? allowedPlatforms.includes(signedInPlatform) : true

  if (isExcluded || !isAllowed) {
    if (from.name === null) {
      next(HOME_ROUTE)
      return routerState.REDIRECTED
    }

    next(false)
    return routerState.CANCELED
  }

  return routerState.ALLOWED
}
